module.exports = __webpack_public_path__ + "static/img/Suijkerbuijk-Bas.f82d468.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew_cast/nl/Suijkerbuijk-Bas.jpg
// module id = MNVi
// module chunks = 1